import { HttpContextToken } from '@angular/common/http';

/** A best-effort background request: a 401 on it must not sign the member out. */
export const BACKGROUND_REQUEST = new HttpContextToken<boolean>(() => false);
